<template>
  <div class="bmui-cell_arrow2">
    <p class="bmui-cell_arrow2-title">{{ title || 'TITLE' }}<span v-show="isNeed" class="bmui-cell_arrow2-isNeed">*</span></p>
    <i class="bmui-cell_arrow2-icon"/>
  </div>
</template>
<script>
export default {
  name: 'BmuiCellArrow2',
  props: {
    title: {
      type: String,
      default: ''
    },
    isNeed: {
      type: Boolean,
      default: false
    }
  }
}
</script>
